import { render, staticRenderFns } from "./PartnersAddUpdate.vue?vue&type=template&id=b4646ddc&"
import script from "./PartnersAddUpdate.vue?vue&type=script&lang=js&"
export * from "./PartnersAddUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PartnersAddUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports